import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClassificationPercentageChartComponent } from './classification-percentage-chart.component';

@NgModule({
  declarations: [
    ClassificationPercentageChartComponent // Declare the component here
  ],
  imports: [
    CommonModule // Import CommonModule for common directives
  ],
  exports: [
    ClassificationPercentageChartComponent // Export the component so it can be used in other modules
  ]
})
export class ClassificationPercentageChartModule { }
